// localStorage access that cannot take the app down.
//
// In a cross-site iframe with third-party storage blocked — Safari's default,
// and Chrome with third-party cookies off — touching localStorage throws a
// SecurityError. Unguarded, that throws during render and the visitor sees a
// blank iframe with nothing in the UI to explain it.
//
// Storage is only ever a convenience here (remembered email, opt-in flag,
// auth token), so every failure degrades to "not remembered" rather than
// breaking the signup.

export const isStorageAvailable = () => {
  try {
    return typeof localStorage !== 'undefined' && localStorage !== null;
  } catch (e) {
    return false;
  }
};

/**
 * @param {string} key
 * @returns {string|null} the stored value, or null if unset or unavailable
 */
export const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn('localStorage unavailable, reading', key, e);
    return null;
  }
};

/**
 * @returns {boolean} whether the value was actually persisted
 */
export const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn('localStorage unavailable, writing', key, e);
    return false;
  }
};

export const safeRemove = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    console.warn('localStorage unavailable, removing', key, e);
    return false;
  }
};

export const safeClear = () => {
  try {
    localStorage.clear();
    return true;
  } catch (e) {
    console.warn('localStorage unavailable, clearing', e);
    return false;
  }
};
